import React from 'react';
import cars01 from '../../assets/img/cars01.png';
import searchicon from '../../assets/img/searchicon.png';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import UrCarAction from './UrCarAction';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PageNotFound from '../FallBackUI/PageNotFound';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
const URcar = (props) => {
  const { urcarBack, id } = props.location.state;
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [carDetail, setCarDetail] = useState([]);
  const [soldcarDetail, setSoldCarDetail] = useState([]);
  const successData = useSelector(state => state.LoginReducer.payload);
  const [VINNumber, setVINNumber] = useState("");
  const [year, setYear] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [activecar, setActivecar] = useState("");
  const [vinError, setVinError] = useState("");
  const [scheduletodate, setScheduleToDate] = useState(null);
  const [scheduleDate, setScheduleDate] = useState(null);
  const [fromDateError, setFromDateError] = useState("");
  const [carDetailForExcel, setCarDetailForExcel] = useState([]);
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false)

  const getcar = () => {
    let request = {
      seller_dealer_id: successData.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    console.log("+++++++++==++", request)
    API.post('seller_urcar/condition', request).then(res => {
      console.log("response", res.data.data);
      // const {results} = res.data.data;
      console.log("Response data", res.data.data);
      //if(results.length>0){
      if (res.data.success === true) {
        setCarDetail(res.data.data);
        if (res.data.data.length > 0) {

          setCarDetailForExcel(res.data.data.map(value => {
            return {
              vin_no: value.vin_no,
              model: value.model,
              make: value.make,
              year: value.year
            }
          }))
        }
        console.log("car Detail", res.data.data);
        setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }
  const getsoldcar = () => {
    let request = {
      seller_dealer_id: successData.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    console.log("+++++++++==++", request)
    API.post('recentlysoldcars/condition', request).then(res => {
      console.log("sold response", res.data.data);
      // const {results} = res.data.data;
      console.log(" sold Response data", res.data.data);
      //if(results.length>0){
      if (res.data.success === true) {
        setSoldCarDetail(res.data.data);
        console.log("sold car Detail", res.data.data);
        // setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }
  const soldredirectpage = (pathid, seller_data, title_status_name) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/cardetails/"+pathid);
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/carlist", id: pathid, titlesold: title_status_name }
    });
  }
  const rerunCarPage = (pathid, seller_data) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/reRunEditdetails/"+pathid);
    history.push({
      pathname: "/reRunEditdetails",
      state: { backURL: "/urcar", id: pathid },
    });
  }
  useEffect(() => {
    getcar();
    getsoldcar();
  }, [scheduletodate, scheduleDate]);

  const redirectpage = (pathid, seller_data) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/cardetails/"+pathid);
    if (seller_data.status === "sold") {


      // history.push("/cardetails/"+pathid);
      history.push({
        pathname: "/soldcardetails",
        state: { backURL: "/urcar", id: pathid }
      });
    } else {
      history.push({
        pathname: "/cardetails",
        state: { backURL: "/urcars", id: pathid },
      });
    }
  }
  const searchCarDetail = () => {
    setVinError("")
    if (VINNumber.length > 0 && VINNumber.length < 6) {
      setVinError("VIN number must have last 6 digit")
      return;
    }
    else if (VINNumber.length > 6) {
      setVinError("VIN number accept only last 6 digit")
      return;
    }

    if (scheduletodate) {
      if (!scheduleDate) {
        setFromDateError("From Date is required")
        return;
      }
    }
    let request = {
      seller_dealer_id: successData.seller_dealer_id,
      make: make,
      model: model,
      year: year,
      vin_no: VINNumber,
      // style: style,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      active: activecar == "" ? "" : Number(activecar),
      fromdate: scheduleDate == null ? "" : convert(scheduleDate),
      todate: scheduleDate == null ? "" : scheduletodate == null ? convert(new Date()) : convert(scheduletodate),
    }

    API.post("urcar_search/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setCarDetail(res.data.data);
          console.log("urcar_search data", res.data.data);
          if (res.data.data.length > 0) {
            setCarDetailForExcel(res.data.data.map(value => {
              return {
                vin_no: value.vin_no,
                model: value.model,
                make: value.make,
                year: value.year
              }
            }))
          }

        }
        else {
          setErrors(res.data.error)
          setErrorFlag(true)
        }
      }).catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  }
  useEffect(() => {
    // console.log("id value",id)
    let intervalId;
    intervalId = setInterval(() => {
      getcar();
    }, 10000)
    return () => clearInterval(intervalId);
  }, [])

  const exportToExcel = async (data, columns, fileName = 'URCar') => {
    try {
      // Create workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('URCar');

      // Add headers
      const headerRow = worksheet.addRow(columns.map(col => col.label));
      headerRow.font = { bold: true };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      };

      // Add data rows
      data.forEach(item => {
        const row = columns.map(col => {
          // Handle nested properties if needed
          const value = col.value.split('.').reduce((obj, key) => obj && obj[key], item);
          return value || '';
        });
        worksheet.addRow(row);
      });

      // Auto-fit columns
      worksheet.columns.forEach(column => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellValue = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, cellValue.length + 2);
        });
        column.width = Math.min(maxLength, 30);
      });

      // Generate buffer and save
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    }
  };
  return (

    <main id="main" class="inner-page">
      {loading ? <Loading /> :

        <div id="recently-cars" class="recently-cars soldCars" >

          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div class="container-fluid aos-init aos-animate" >
              <div class="back-btn">
                <a class="back-btn-primary" onClick={() => history.push(urcarBack)}><i class="bx bx-chevron-left"></i> Back</a>
              </div>
              <div class="section-title">
                <h2>URCars</h2>
              </div>
              <div class="downloadBtn">
                <div class="downBtn">
                  <i class="icofont-download"></i>
                  <span onClick={exportToExcel} style={{ cursor: 'pointer' }}>
                    Download Excel
                  </span>
                </div>
              </div>
              <div class="row">

                <div class="searchlistform col-lg-12">
                  <div class="searchblock">
                    <div class="form-group">
                      <label class="control-label" for="location">Year</label>
                      <input class="form-control border-end-0" type="text" id="location" placeholder="Enter Car Year"
                        onChange={(e) => setYear(e.target.value)} />
                    </div>


                    <div class="form-group">
                      <label class="control-label" for="dealername">Make</label>
                      <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Make"
                        onChange={(e) => setMake(e.target.value)} />
                    </div>

                    <div class="form-group">
                      <label class="control-label" for="dealername">Model</label>
                      <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Model"
                        onChange={(e) => setModel(e.target.value)} />
                    </div>

                    <div class="form-group ">
                      <label class="control-label" for="date">VIN No</label>
                      <input class="form-control border-end-0 " type="text" id="date" placeholder="Enter Last 6 Digit"
                        onChange={(e) => setVINNumber(e.target.value)} />

                    </div>

                    <div class="form-group carStatus">
                      <label class="control-label" for="dealername">Car Status</label>
                      <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                        onChange={(e) => setActivecar(e.target.value)}>
                        <option style={{ "display": "none" }}>Select</option>
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>

                      </select>
                      {/* <label class="control-label" for="dealername">Style</label> 
                                <input class="form-control border-end-0" type="text"  id="dealername" placeholder="Enter Car Style"
                                onChange={(e) => setStyle(e.target.value)}/> */}
                    </div>

                    <div className="form-group dateBlock">
                      <label className="control-label" for="date">From Date</label>
                      {/* <input className="form-control border-end-0 " type="date" value={scheduleDate}  id="date" onKeyDown={onKeydowninSearch} placeholder="DD-MM-YYYY" onChange={(e) => setScheduleDate(e.target.value)}></input> */}
                      <DatePicker
                        className="form-control textbox" name="date" id="date"
                        autoComplete="off"
                        selected={scheduleDate}
                        onChange={(date) => setScheduleDate(date)}
                        isClearable
                        placeholderText="Date"
                        required
                        onChangeRaw={handleDateChangeRaw}
                      />

                    </div>
                    <div className="form-group dateBlock">
                      <label title=" Select From date first to proceed !" className="control-label" for="todate">To Date</label>
                      {scheduleDate != "" ?
                        <DatePicker
                          className="form-control textbox" name="todate" id="todate"
                          selected={scheduletodate}
                          onChange={(date) => setScheduleToDate(date)}
                          isClearable
                          placeholderText="Date"
                          required
                          onChangeRaw={handleDateChangeRaw}
                        /> :
                        <DatePicker
                          className="form-control textbox" disabled name="todate" id="todate"
                          selected={scheduletodate}
                          onChange={(date) => setScheduleToDate(date)}
                          isClearable
                          placeholderText="Date"
                          required
                          onChangeRaw={handleDateChangeRaw}
                        />}
                    </div>

                    <div class=" form-group searchbtn">
                      {/*<img src={searchicon} onClick={searchCarDetail}/>*/}
                      <button onClick={searchCarDetail}><i class="bx bx-search"></i></button>
                    </div>



                  </div>
                </div>

                <div class="errorMsgBox col-lg-12">
                  <p className="form-input-error" >{vinError}</p>
                  <p className="form-input-error" >{fromDateError}</p>

                </div>

              </div>


              <div class="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
                {carDetail.length > 0 ? carDetail
                  .map((item) =>

                    <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" onClick={() => { item.isActive === "1" ? redirectpage(item.carid, item) : rerunCarPage(item.carid, item) }}>
                      {item.isActive === "1" ?
                        <div class="car-item ">

                          {/* <div class="soldRibbon">
                        <h4 class="ribbon">Sold Car</h4>
                    </div>
     */}

                          <img src={item.image} class="carImg" alt="..." onClick={() => { redirectpage(item.carid, item) }} />
                          <div class="cars-content">
                            <h3><a >{item.year} {item.make} {item.model}</a></h3>
                            <div class="d-flex align-items-center mb-3">
                              <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} m</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
                              {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                            </div>

                            {item.status == "sold" ?
                              <div class="cars-prices">
                                <div class="prices">
                                  <a class="cta-btns SellPrice" >Sold- <span>${item.sold_price} </span></a>
                                </div></div> :
                              <div class="cars-prices">
                                {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                  <div class="prices">
                                    <a class="cta-btns SellPrice" >Sell it now - <span>${item.max_price} </span></a>
                                  </div>}
                                {/* <a class="cta-btns SellPrice" > Sell it now - <span>${item.max_price}</span></a> */}
                                {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :

                                  <div class="prices">
                                    <a class="cta-btns highBid" >High Bid : <span> ${item.high_bid}</span></a>
                                  </div>}
                              </div>}
                          </div>
                        </div> :

                        <div class="car-item runout">
                          <div class="runoutOverlay"></div>

                          <img src={item.image} class="carImg" alt="..." />
                          <div class="runoutContent">
                            <p>Its not running now</p>
                            <div class="text-center"><a class="cta-btns runit" href="">Run it</a></div>
                          </div>
                          <div class="cars-content">
                            <h3><a >{item.year} {item.make} {item.model}</a></h3>
                            <div class="d-flex align-items-center mb-3">
                              <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} m</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
                              {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                            </div>
                            {item.status == "sold" ?
                              <div class="cars-prices">
                                <div class="prices">
                                  <a class="cta-btns SellPrice" >Sold- <span>${item.sold_price} </span></a>
                                </div></div> :
                              <div class="cars-prices">
                                {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :


                                  <div class="prices">
                                    <a class="cta-btns SellPrice" >Sell it now - <span>${item.max_price} </span></a>
                                  </div>}
                                {/* <a class="cta-btns SellPrice" > Sell it now - <span>${item.max_price}</span></a> */}
                                {/* <a class="cta-btns highBid" >High Bid :<span>${item.high_bid}</span></a> */}
                                {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                  // <div class="cars-prices">
                                  // <a class="cta-btns highBid" >High Bid : <span > $0</span></a>
                                  // </div>:
                                  <div class="prices">
                                    <a class="cta-btns highBid" >High Bid : <span> ${item.high_bid}</span></a>
                                  </div>}
                              </div>}
                          </div>
                        </div>}
                    </div>) : <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}


                {/* <div class="text-center col-lg-12">
                    <a href="#" class="more-btn loadmore">Load More <i class="bx bx-chevron-right"></i></a>
                  </div> */}
              </div>
            </div>}


        </div>}
      <section id="playstoreBlock" class="playstoreBlock">
        <div class="container">
          <div class="row content">
            <div class="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />

            </div>

          </div>

        </div>
      </section>
    </main>

  )
}
export default URcar;